export default __webpack_public_path__ + "static/media/sheet_thumb10_health@2x.e3241e8b.png";